import { render } from "./ColumnsSettings.vue?vue&type=template&id=94797350"
import script from "./ColumnsSettings.vue?vue&type=script&lang=js"
export * from "./ColumnsSettings.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./ColumnsSettings.vue?vue&type=style&index=0&id=94797350&module=true&lang=less"
cssModules["$style"] = style0

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__